const DEVICE_PARAMS = {
  CONTRACT_TYPE: 'CONTRACT_TYPE',
  PRICE_PER_KWH: 'PRICE_PER_KWH',
  PRICE_CURRENCY: 'PRICE_CURRENCY',
  OFF_PEAK_HOURS: 'OFF_PEAK_HOURS',
  OFF_PEAK_HOURS_PRICE_PER_KWH: 'OFF_PEAK_HOURS_PRICE_PER_KWH',
  PEAK_HOURS_PRICE_PER_KWH: 'PEAK_HOURS_PRICE_PER_KWH',
  LAST_REFRESH: 'LAST_REFRESH',
  NUMBER_OF_STATES: 'NUMBER_OF_STATES'
};

export { DEVICE_PARAMS };
